export type SELF_APPLY_USER_TYPE = "agency" | "candidate";

export enum SELF_APPLY_USER_TYPE_ENUM {
  AGENCY = "agency",
  CANDIDATE = "candidate",
}
